import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {TaxonomyApprovalRequest} from "~/services/classes/AiClasses";
import type {TaxonomyApprovalRequestStateSerializer} from "~/services/classes/TaxonomyApproval";
import {
    taxonomyApprovalRequestUrl,
    taxonomyApprovalStateUrl,
} from "~/pages/taxonomy-builder-v2/services/taxonomyBuilderUrls";

export const taxonomyApprovalRequestQueryKey = (approvalId: number) => [taxonomyApprovalRequestUrl(approvalId)] as const;
export const taxonomyApprovalStateQueryKey = (approvalId: number) => [taxonomyApprovalStateUrl(approvalId)] as const;

/** The approval request: the requester's notes, the reply, the status. */
export function useTaxonomyApprovalRequestQuery(approvalId: number) {
    return useCustomQuery({
        queryKey: taxonomyApprovalRequestQueryKey(approvalId),
        queryFn: async () => (await queryHttp.get<TaxonomyApprovalRequest>(taxonomyApprovalRequestUrl(approvalId))).data,
    });
}

/** The approver's copy of the tree (with its `changes`) and its history. */
export function useTaxonomyApprovalStateQuery(approvalId: number) {
    return useCustomQuery({
        queryKey: taxonomyApprovalStateQueryKey(approvalId),
        queryFn: async () => (await queryHttp.get<TaxonomyApprovalRequestStateSerializer>(taxonomyApprovalStateUrl(approvalId))).data,
    });
}
